<script>
// @ts-ignore-start

import { Input } from './mixins';

import datePicker from 'vue2-daterange-picker';
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';

export default {
  props: {
    singleDatePicker: {
      type: [Boolean, String],
      default: false,
    },
  },
  extends: datePicker,

  mounted() {
    const endDate = this.dateRange.endDate || null;
    if (this.singleDatePicker && this.singleDatePicker !== 'range') {
      this.end = this.start;
    } else {
      this.end = endDate ? new Date(endDate) : null;
    }
  },

  methods: {
    dateClick(value) {
      if (this.in_selection) {
        this.in_selection = false;
        this.end = this.normalizeDatetime(value, this.end);
        if (this.end < this.start) {
          this.in_selection = true;
          this.start = this.normalizeDatetime(value, this.start);
        }
        if (!this.in_selection) {
          this.onSelect();
          if (this.autoApply) {
            this.clickedApply();
          }
        }
      } else {
        this.start = this.normalizeDatetime(value, this.start);
        this.end = this.normalizeDatetime(value, this.end);
        if (!this.singleDatePicker || this.singleDatePicker === 'range') {
          this.in_selection = true;
        } else {
          this.onSelect();
          if (this.autoApply) {
            this.clickedApply();
          }
        }
      }
    },
  },

  computed: {
    rangeText() {
      let range = this.startText;
      if (!this.singleDatePicker || this.singleDatePicker === 'range') {
        range += this.locale.separator + this.endText;
      }
      return range;
    },
  },
};
// @ts-ignore-end
</script>
